import * as React from 'react';

import { PropertyImportantInfo } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';

const ImportantInfoWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <SimpleLazyLoadWrapper>
      <PropertyImportantInfo inputs={inputs} />
    </SimpleLazyLoadWrapper>
  </UitkSpacing>
);

export const SharedUiImportantInfoWrapper = withSharedUiPropertyDetails(ImportantInfoWrapper);
SharedUiImportantInfoWrapper.displayName = 'SharedUiImportantInfoWrapper';
